import { Browser } from "../../core/browser";
import { AuxiliumComponent } from "../auxilium-component";

export default class AccordionItem extends AuxiliumComponent {
	static observable = ["heading"];
	static observableBooleans = ["open"];

	parsedCallback() {
		this.appendChild(document.createElementWithContents("div", this.childNodes, {
			className: "accordion__content"
		}));

		const button = document.createElementWithContents("button", document.createElementWithContents("span", this.heading), {
			className: "btn--base btn-accordion-toggle",
			type: "button",
			ariaExpanded: this.open,
			onclick: () => this.open = !this.open
		}), toggleIcon = document.createElementWithContents("chip-icon", null, {
			className: "accordion__icon",
			icon: "fas fa-chevron-down"
		});

		if (Browser.GetFlavour() === "gov") {
			button.appendChild(document.createElementWithContents("div", "<chip-icon></chip-icon> <span>Show</span>", {
				className: "accordion--gov-toggle"
			}));
		}

		button.prepend(toggleIcon);

		if (this.heading) {
			this.prepend(button);
		}
	}

	attributeChanged(name, _, newValue) {
		if (name === "open") {
			if (this.IsAttributeValueTrue(newValue)) {
				this.Open();
			} else {
				this.Close();
			}
		}
	}

	#GetItems() {
		const container = this.closest("chip-accordion");

		if (container && !container.multiple) {
			return [...container.querySelectorAll("chip-accordionitem") ?? []];
		} else {
			return [this];
		}
	}

	Toggle() {
		if (!this.open) { this.Open(); }
		else { this.Close(); }
	}

	Open() {
		this.open = true;
		this.#GetItems().filter(x => x !== this && x.open).forEach(x => x.Close());

		this.querySelector(".btn-accordion-toggle")?.setAttribute("aria-expanded", true);

		const toggleText = this.querySelector(".accordion--gov-toggle span");

		if (toggleText) {
			toggleText.textContent = "Hide";
		}

		this.closest("chip-accordion")?.UpdateState();
	}

	Close() {
		this.open = false;
		this.querySelector(".btn-accordion-toggle")?.setAttribute("aria-expanded", false);

		const toggleText = this.querySelector(".accordion--gov-toggle span");

		if (toggleText) {
			toggleText.textContent = "Show";
		}

		this.closest("chip-accordion")?.UpdateState();
	}
}
